<template>
  <div>
    <el-form :inline="true">
      <el-form-item>
        <el-input
          v-model="searchForm.phone"
          placeholder="手机号"
          clearable
          style="width: 200px"
        >
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="sendDate"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button @click="getSmsSendRecordList">搜索</el-button>
      </el-form-item>
    </el-form>

    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      border
      stripe>

      <el-table-column
        prop="phone"
        label="手机号"
        width="150">
      </el-table-column>
      <el-table-column
        prop="type"
        label="模板类型"
        width="120">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.type == 0">验证码</el-tag>
          <el-tag v-else-if="scope.row.type == 1">短信通知</el-tag>
          <el-tag v-else-if="scope.row.type == 2">推广短信</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="smsContent"
        label="模板内容"
        width="600">
      </el-table-column>
      <el-table-column
        prop="sendState"
        label="发送状态"
        width="120">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.sendState == 0" type="danger">失败</el-tag>
          <el-tag v-else-if="scope.row.sendState == 1" type="success">成功</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="errorCause"
        label="失败原因"
        width="300">
      </el-table-column>
      <el-table-column
        prop="sendTime"
        label="发送时间"
        width="180">
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[10, 20, 50, 100]"
      :current-page="page.current"
      :page-size="page.size"
      :total="page.total">
    </el-pagination>
  </div>
</template>

<script>

  export default {
    name: "SmsSendRecord",
    data() {
      return {
        searchForm: {},
        sendDate: [],
        tableData: [],
        page: {
          total: 0,
          size: 10,
          current: 1,
        },
      }
    },
    created() {
      this.getSmsSendRecordList(this.page)
    },
    methods: {
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.page.size = val
        this.getSmsSendRecordList(this.page)
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.page.current = val
        this.getSmsSendRecordList(this.page)
      },
      getSmsSendRecordList(page) {
        this.$axios.post("/uxm/sms-send-record/pageList", {
          phone: this.searchForm.phone,
          startDate: this.sendDate === null ? null : this.sendDate[0],
          endDate: this.sendDate === null ? null : this.sendDate[1],
          current: page == null ? this.page.current : page.current,
          size: page == null ? this.page.size : page.size,
        }).then(res => {
          this.tableData = res.data.data.records
          this.page.size = res.data.data.size
          this.page.current = res.data.data.current
          this.page.total = res.data.data.total
        })
      },
    }
  }
</script>

<style scoped>
  .el-pagination {
    float: right;
    margin-top: 22px;
  }
</style>
